module.exports = __webpack_public_path__ + "e9e56e7c36c10de8c73d8e4cd7fb41fd.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/system/assets/img/stealth-logo.png
 ** module id = 674
 ** module chunks = 0
 **/